/*eslint no-script-url: 0 */
import React, { Component } from "react";
import ImageFile from './ImageFile';
import { Modal } from 'react-bootstrap';
import ImageEditor from "../ImageEditor/ImageEditor";

class EditImage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			lgShow: false,
		}
	}

	lgClose = () => {
		this.setState({ lgShow: false });
	}

	lgShow = () => {
		this.props.toggleSteps();
		this.setState({ lgShow: true });
	}

 	render() {
	    return (
			<li className="m-b-5">
				<a href="#!" onClick={this.lgShow} className="btn btn-primary default-btn">Edit Image</a>
				{this.props.uploadedFile === null ?
					<Modal
						show={this.state.lgShow}
						onHide={this.lgClose}
						bsSize="large"
						aria-labelledby="contained-modal-title-lg"
					>
						<Modal.Header closeButton>
							<Modal.Title id="contained-modal-title-lg">Edit Image</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<ImageFile {...this.props} />
						</Modal.Body>
					</Modal>
				:
					<ImageEditor lgShowState={this.state.lgShow} lgClose={this.lgClose} lgShow={this.lgShow} {...this.props} />
				}
			</li>
	    );
  	}
}
export default EditImage;